import { useState } from "react"
import Button from "@mui/material/Button"
import IconButton from "@mui/material/IconButton"
import Menu from "@mui/material/Menu"
import MenuItem from "@mui/material/MenuItem"
import Divider from "@mui/material/Divider"
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined"
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined"
import { useAuthContext } from "./context/AuthContext"

export const UserMenu = () => {
  const authCtx = useAuthContext()
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)

  // keep the header stable until the first auth check resolves,
  // so a logged-in user never sees a "login" flash
  if (!authCtx.authReady) {
    return null
  }

  if (!authCtx.user) {
    return (
      <Button
        size="small"
        onClick={authCtx.openLogin}
        sx={{
          color: "var(--muted)",
          fontSize: 12,
          minWidth: 0,
          padding: "2px 8px",
        }}
      >
        Login
      </Button>
    )
  }

  return (
    <>
      <IconButton
        size="small"
        title="Account"
        onClick={(e) => setAnchorEl(e.currentTarget)}
        sx={{ color: "var(--muted)" }}
      >
        <AccountCircleOutlinedIcon fontSize="small" />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        MenuListProps={{ dense: true, sx: { py: 0.5 } }}
      >
        <div
          style={{
            padding: "6px 14px",
            fontSize: 12,
            color: "var(--muted)",
            maxWidth: 220,
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {authCtx.user.email}
        </div>
        <Divider />
        <MenuItem
          dense
          onClick={() => {
            setAnchorEl(null)
            authCtx.logout()
          }}
        >
          <LogoutOutlinedIcon
            fontSize="small"
            style={{ marginRight: 8, color: "var(--muted)" }}
          />
          Log out
        </MenuItem>
      </Menu>
    </>
  )
}
